import { render, staticRenderFns } from "./prjRole.vue?vue&type=template&id=6ddeec89&scoped=true"
import script from "./prjRole.vue?vue&type=script&lang=js"
export * from "./prjRole.vue?vue&type=script&lang=js"
import style0 from "./prjRole.vue?vue&type=style&index=0&id=6ddeec89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddeec89",
  null
  
)

export default component.exports